import axios from "axios";
import { getCookies, setCookies, removeCookies } from "../services/Cookies";
import toast from "react-hot-toast";

const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

const companyApi = axios.create({
  baseURL: process.env.REACT_APP_COMPANY_INFO_URL,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    "X-API-KEY": process.env.REACT_APP_X_API_KEY,
  },
});


// Request Interceptor to add token to headers
api.interceptors.request.use(
  (config) => {
    const token = getCookies("token"); // Access token
    if (token && token !== "null") {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response Interceptor to handle token expiration and refresh
api.interceptors.response.use(
  (response) => response, // Return the response if the request is successful
  async (error) => {
    const originalRequest = error.config;

    const refreshToken = getCookies("refreshToken"); // Get the refresh token from cookies

    // If the token is expired (status 401) and the refresh token exists
    console.log(error.response);
    if (
      error.response?.status === 401 &&
      refreshToken &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true; // Mark this request as retried

      try {
        // Try refreshing the token using the refresh token
        const response = await refreshToken({ refreshToken });

        const newToken = response.data.token; // Get new access token
        const newRefreshToken = response.data.refreshToken; // Get new refresh token
        // toast.success("Session renewed successfully!", {
        //   position: toast?.POSITION?.TOP_CENTER,
        //   autoClose: 3000,
        // });
        // Save the new tokens in cookies
        setCookies("token", newToken, { path: "/" });
        setCookies("refreshToken", newRefreshToken, { path: "/" });
        toast.success('Session renewed successfully!')
        // Retry the original request with the new access token
        originalRequest.headers["Authorization"] = `Bearer ${newToken}`;
        return axios(originalRequest); // Retry the original request with the new token
      } catch (refreshError) {
        // If refresh fails, redirect to login page or handle logout
        console.error("Error refreshing token:", refreshError);
        // toast.error("Session expired. Please log in again.", {
        //   position: toast.POSITION.TOP_CENTER,
        //   autoClose: 5000,
        // });
        // alert('Session expired. Please log in again.')
        setTimeout(() => {
          window.location.href = "/";
        }, 5000); // Redirect after 5 seconds
        removeCookies("token");
        removeCookies("refreshToken");

        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error); // Reject the error if it's not 401 or refresh fails
  }
);

export { api, companyApi };

